import { render, staticRenderFns } from "./WorkspaceChoose.vue?vue&type=template&id=36df8477&"
import script from "./WorkspaceChoose.vue?vue&type=script&lang=js&"
export * from "./WorkspaceChoose.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceChoose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports